import { GraphActions } from "features/dashBoard/types"

import {
  RectangleOutlined  as SelectRectIcon,
  PentagonOutlined as SelectPolygonIcon
} from '@mui/icons-material'

export const ScatterPlotGraphActions: GraphActions[] = [
  {
    label: '矩形選択',
    toolBtn: <SelectRectIcon fontSize='small'/>,
    action: (instance) => {
      const echarts = instance.getEchartsInstance()
      echarts.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: {
          brushType: 'rect',
          brushMode: 'single'
        }
      }, {
        silent: true
      })
      //console.log('selected rectangle brush')
    }
  },
  {
    label: '自由選択',
    toolBtn: <SelectPolygonIcon fontSize='small'/>,
    action: (instance) => {
      const echarts = instance.getEchartsInstance()
      echarts.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: {
          brushType: 'polygon',
          brushMode: 'single'
        }
      }, {
        silent: true
      })
      //console.log('selected plygon brush')
    }
  }
]
